import React, {useEffect} from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../ui/Dialog/DialogActions";
import AddStudentForm from "../../../../../Groups/pages/GroupView/components/Students/CreateNew/AddStudentForm";
import {withRouter} from "react-router-dom";

const styles = theme => ({
  dialog: {
    width: "550px"
  }
});

const CreateNewPersonModal = ({
                     open,
                     handleClose,
                     createStudent,
                     isCreatingStudent,
                     requestData,
                     classes,
                     history
                   }) => {
  const [formData, updateFormData] = React.useState(null);

  const onConfirm = () => {
    createStudent(formData);
  };

  const onClose = () => {
    updateFormData(null);
    handleClose();
  };

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Создать обучающегося на основе заявки</DialogTitle>
        <DialogContent>
          <AddStudentForm
            initialData={requestData}
            onFormChange={updateFormData}
            disabled={isCreatingStudent}
            hideCheckbox={true}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isCreatingStudent}
            disabled={isCreatingStudent}
            onClick={() => onConfirm()}
            color="green"
          >
            Добавить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(withRouter(CreateNewPersonModal));
